var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAssetlink = function SvgAssetlink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#BD10E0",
    strokeLinecap: "round",
    strokeWidth: 1.75,
    d: "m11.082 16.917 5.833-5.833M19.654 17.045 22.698 14A6.15 6.15 0 1 0 14 5.302l-3.044 3.044m6.088 11.308L14 22.698A6.15 6.15 0 0 1 5.302 14l3.044-3.044"
  })));
};
export default SvgAssetlink;